var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNorsk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 8.33337H0.5V39.667H47.5V8.33337Z",
    fill: "#BA0C2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 27.6611H19.0609V39.6666H17.3587H13.4413H11.7392V27.6611H0.5V25.9579V22.0416V20.3383H11.7392V8.33289H13.4413H17.3587H19.0609V20.3383H47.5V22.0416V25.9579V27.6611Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 22.0416V25.9579H17.3587V39.6666H13.4413V25.9579H0.5V22.0416H13.4413V8.33289H17.3587V22.0416H47.5Z",
    fill: "#00205B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorsk);
export default __webpack_public_path__ + "static/media/Norsk.4c054406.svg";
export { ForwardRef as ReactComponent };